import React, { Component } from 'react';
import {Form, Button,  FormGroup, Label, Input, Card, CardBody } from 'reactstrap';
class TrainStatus extends Component { 
  constructor(props) {
    super(props);

  }
  componentDidMount(){
   
  }
    goBack() {
        window.history.back();
      }
    render(){
        return(
            <div className="modal fade show d-block"     >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header px-4 d-block">
            
              
               <div className="row">
              	<div className="col-md-10">
              		 <h4 className="modal-title" ><a onClick={this.goBack}   className="back-button cpointer" >
                <i className="fas fa-arrow-circle-left"></i></a> Group Name -  Train Status</h4>
              	</div>
              	<div className="col-md-2 text-right">
              	</div>
              </div>
            
            </div>
            <div className="modal-body p-4">
              <div className='row'>
              <div className='col-md-12'>
              <h4>Training Progress 75%</h4>
              </div>
                  <div className='col-md-12'>
                  <div className="progress">
                            <div style={{width: "75%"}} className="progress-bar"></div>
                </div>
                  </div>
              </div>
            
              
           
</div>
                                  
       
   
          </div>
        
        </div>
      </div>
        )
    }
}
export default TrainStatus